import * as React from 'react';

export interface HeaderProps {
}

export class Header extends React.Component<HeaderProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (
            <section className='ms-welcome__header ms-bgColor-neutralLighter ms-u-fadeIn500'>
                <h1 className='ms-fontSize-xl ms-fontWeight-light ms-fontColor-neutralPrimary'>lex<b>search</b></h1>
            </section>
        );
    };
};



// WEBPACK FOOTER //
// ./components/header.tsx